import React, {useState} from "react";
import { BsTwitter} from 'react-icons/bs';
import { FaFacebookF, FaGithub, FaPhone, FaMailBulk } from 'react-icons/fa';
import { images } from '../../constants';
import {db} from '../../firebase';

import "./Contact.scss";


const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [numero, setNumero] = useState("");
  const [sujet, setSujet] = useState("");
  const [loader, setLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

     db.collection('contact').add({
      name:name,
      email:email,
      message:message,
      numero:numero,
      sujet:sujet,
    })
    .then(() => {
      alert('Message envoyé avec succès 👍!!');
      setLoader(false);
    })
    .catch((error) => {
      alert(error.message);
      setLoader(false);
    });
    setName("");
    setNumero("");
    setMessage("");
    setSujet("");
    setEmail("");
  };




  return (
    <>
      <section className='Contact' id='contact'>
        <div className='container top'>
          <div className='heading text-center'>
            <h4>CONTACT-NOUS</h4>
            {/* <h1>Contactez-nous</h1> */}
          </div>

          <div className='content d_flex'>
            <div className='left'>
              <div className='box box_shodow'>
                <div className='img'>
                  <img src={images.web} alt='web' />
                </div>
                <div className='details'>
                  <h1>INFORMATIONS</h1>
                  <p>Téléphone <FaPhone/> :<a href="tel: +235 65 75 81 37"> +235 65 75 81 37</a></p>
                  <p>Email <FaMailBulk/>: <a href='aldolo@contactealdolo.com'>aldolo@contactealdolo.com</a></p>
                  <div className='button f_flex'>
                      <button className='btn_shadow'>
                      <a href='https://github.com/aldolo49'><BsTwitter/></a>
                      </button>
                      <button className='btn_shadow'>
                      <a href='https://facebook.com/aldoloxyz'><FaFacebookF/></a>
                      </button>
                      <button className='btn_shadow'>
                      <a href='https://github.com/aldolo49'><FaGithub/></a>
                      </button>
                  </div>
                  </div>
              </div>
            </div>

            <div className='right' onSubmit={handleSubmit}>
              <form >
              <div className='input'>
                    <label>NOM</label>
                    <input
                      type='text'
                      name='fullname'
                      placeholder='Votre nom'
                      required
                      value={name}
                      onChange={(e)=> setName(e.target.value)}
                      />
                  </div>
                  <div className='input'>
                    <label>NUMÉRO DE TÉLÉPHONE</label>
                    <input
                      type='phone'
                      name='phone'
                      placeholder='Votre numéro de téléphone'
                      required
                      value={numero}
                      onChange={(e) => setNumero(e.target.value)}
                    />
                  </div>
                <div className='input'>
                  <label>EMAIL </label>
                  <input
                    value={email}
                    // type='email'
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder='Votre Email'
                    required
                  />
                </div>
                <div className='input'>
                  <label>SUJET </label>
                  <input
                    type='text'
                    name='subject'
                    placeholder='Le sujet'
                    required
                    value={sujet}
                    onChange={(e) => setSujet(e.target.value)}
                  />
                </div>
                <div className='input'>
                  <label>MESSAGE</label>
                  <textarea cols='30' rows='10' name='message'
                    // type='text'
                    placeholder='Votre message'
                    required
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                 >
                  </textarea>
                </div>
                <button
                  className='btn_shadow'
                  type="submit"
                >
                  ENVOYER LE MESSAGE <i className='fa fa-long-arrow-right'></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact;